<template>
    <div class="transition-all ease-in-out duration-500" :class="hasErrors ? 'mb-4 opacity-100 block' : 'mb-0 opacity-0 hidden'">
        <div v-if="validations && this.hasErrors && !hideErrors" class="relative h-0">
            <div class="pointer-events-none w-full z-10 text-red text-xs py-1 text-red pointer-events-none">
                <template v-if="onlyFirstMessage && validations.length >= 1">
                    <span v-show="validations[0].condition" class="block whitespace-no-wrap">
                    {{ validations[0].text }}
                    </span>
                </template>
                <template v-else>
                    <span
                        v-for="(validation, index) in validations"
                        :key="index"
                        v-show="validation.condition"
                        class="block whitespace-no-wrap"
                    >
                    {{ validation.text }}
                </span>
                </template>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            validations: {
                type: Array,
                default: () => []
            },
            hideErrors: {
                type: Boolean,
                required: false,
                default: true
            },
            hasErrors: {
                type: Boolean,
                required: false,
                default: false
            },
            onlyFirstMessage: {
                type: Boolean,
                required: false,
                default: true
            }
        }
    }
</script>
